function initializeCutimArticleToc(root = document) {
  root.querySelectorAll('.cutim-article-body').forEach((body) => {
    if (body.dataset.tocReady) return;
    body.dataset.tocReady = 'true';
    const text = body.textContent.trim();
    const headings = Array.from(body.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
    if (text.split(/\s+/).length < 800 || headings.length < 4 || body.querySelector('nav, a[href^="#"]')) return;
    const nav = document.createElement('nav');
    nav.className = 'cutim-article-toc';
    nav.setAttribute('aria-label', 'Table of contents');
    const title = document.createElement('p');
    title.textContent = 'On this page';
    const list = document.createElement('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = body.id + '-heading-' + (index + 1);
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + encodeURIComponent(heading.id);
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', () => {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      });
      item.append(link);
      list.append(item);
    });
    nav.append(title, list);
    body.prepend(nav);
  });
}
initializeCutimArticleToc();
document.addEventListener('shopify:section:load', (event) => initializeCutimArticleToc(event.target));
